export default __webpack_public_path__ + "static/media/Engrace_Masterplan.7cc56e98.pdf";